import React from "react";
import ModalContainer from "../../../containers/Modal/ModalContainer";

import InterviewHistory from "./InterviewHistory";
import { useTranslation } from "react-i18next";

const ModalInterviewHistory = ({
  isOpen,
  setIsOpen,
  interviewHistory,
  interview
}) => {
  const { t } = useTranslation();

  return (
    <ModalContainer
      modalTitle={t("History")}
      isOpen={isOpen}
      closeModal={() => setIsOpen(false)}
      crossmarkAction={() => setIsOpen(false)}
    >
      <InterviewHistory
        interviewHistory={interviewHistory}
        interview={interview}
      />
    </ModalContainer>
  );
};

export default ModalInterviewHistory;
